<template>
  <div class="admin-page">
    <h3>用户拉新 / 礼券全景</h3>
    <div class="admin-toolbar">
      <el-input v-model="query.username" placeholder="用户名" clearable class="filter-input" />
      <el-input v-model="query.userId" placeholder="用户 ID" clearable class="filter-input" />
      <el-button type="primary" @click="search">查询</el-button>
    </div>
    <el-card v-if="overview" v-loading="loading" shadow="never">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="用户">{{ overview.nickname }} ({{ overview.username }})</el-descriptions-item>
        <el-descriptions-item label="ID">{{ overview.userId }}</el-descriptions-item>
        <el-descriptions-item label="臻享资格">
          <el-tag :type="overview.isPartner ? 'warning' : 'info'" size="small">
            {{ overview.isPartner ? '已开通' : '未开通' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="臻享客户归属">#{{ overview.partnerUserId || '—' }}</el-descriptions-item>
        <el-descriptions-item label="礼券绑定限制">
          {{ overview.referralBonusBlocked ? '已禁止再绑' : '正常' }}
        </el-descriptions-item>
        <el-descriptions-item label="拥有礼券数">{{ overview.ownedCouponsCount }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="overview.referralBonusBlocked" class="actions">
        <el-button type="primary" @click="unblockUser">解除绑定限制</el-button>
      </div>
      <div v-if="overview.referralBinding" class="binding-block">
        <h4>礼券绑定</h4>
        <p>券号 {{ overview.referralBinding.couponNo }} · {{ couponTypeLabel(overview.referralBinding.couponType) }} · 礼遇已发 {{ overview.referralBinding.bonusPaid === 1 ? '是' : '否' }}</p>
        <el-button
          v-if="overview.referralBinding.bonusPaid === 1"
          type="warning"
          size="small"
          @click="clawbackBinding"
        >
          冲正该绑定礼遇
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  adminClawbackReferralBonus,
  adminUnblockReferralBonus,
  couponTypeLabel,
  fetchAdminReferralUserOverview
} from '@/utils/referralCoupon'

export default {
  name: 'AdminReferralUserOverview',
  data() {
    return {
      loading: false,
      query: { username: '', userId: '' },
      overview: null
    }
  },
  methods: {
    couponTypeLabel,
    async search() {
      const userId = Number(this.query.userId) || 0
      const username = (this.query.username || '').trim()
      if (!userId && !username) {
        this.$message.warning('请输入用户名或用户 ID')
        return
      }
      this.loading = true
      try {
        this.overview = await fetchAdminReferralUserOverview({ userId: userId || undefined, username })
      } catch (e) {
        this.$message.error(e.message || '查询失败')
        this.overview = null
      } finally {
        this.loading = false
      }
    },
    async unblockUser() {
      if (!this.overview) return
      try {
        await adminUnblockReferralBonus({ userId: this.overview.userId })
        this.$message.success('已解除限制')
        await this.search()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    async clawbackBinding() {
      const binding = this.overview?.referralBinding
      if (!binding?.id) return
      try {
        await this.$confirm('冲正该绑定的已发礼遇？', '冲正确认', { type: 'warning' })
      } catch {
        return
      }
      try {
        const data = await adminClawbackReferralBonus(binding.id)
        this.$message.success(data.message || '已冲正')
        await this.search()
      } catch (e) {
        this.$message.error(e.message || '冲正失败')
      }
    }
  }
}
</script>

<style scoped>
.filter-input { width: 160px; margin-right: 8px; }
.binding-block { margin-top: 16px; }
.binding-block h4 { margin: 0 0 8px; }
.actions { margin-top: 12px; }
</style>
